import { render, staticRenderFns } from "./krisma.vue?vue&type=template&id=1d889f3e&"
import script from "./krisma.vue?vue&type=script&lang=js&"
export * from "./krisma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports